// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"f737d0d3","45":"bd4b570c","626":"bd4b570c","901":"5f1e3d3e"}[chunkId] + ".chunk.css";
};